import { cn } from "@/lib/utils";

interface ItemCardSkeletonProps {
  className?: string;
}

/**
 * ItemCard的骨架屏组件，用于在数据加载时显示
 */
export const ItemCardSkeleton = ({ className }: ItemCardSkeletonProps) => {
  return (
    <div
      className={cn("w-full h-full cursor-pointer group relative rounded-md", className)}
    >
      {/* 骨架屏封面区域 */}
      <div className="w-full h-[195px] bg-gray-200 animate-pulse rounded-md flex flex-col items-center justify-center relative">
        {/* 骨架屏图片占位 */}
        <div className="w-full h-full bg-gray-200 rounded-md"></div>
      </div>
      
      <div className="w-full absolute -bottom-2 translate-y-full">
        {/* 骨架屏时间占位 */}
        <div className="w-full text-center mt-1">
          <div className="h-3 bg-gray-200 animate-pulse rounded w-2/3 mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

/** 批量骨架屏组件 */
export const ItemCardSkeletonList: React.FC<{ count?: number }> = ({ 
  count = 8, 
}) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ItemCardSkeleton key={index} />
      ))}
    </>
  );
};